import { useEffect, useState } from 'react';
import { api, ensureSession } from '../api.ts';

interface BottomNavProps {
  currentRoute: string;
  navigate(path: string): void;
}

export function BottomNav({ currentRoute, navigate }: BottomNavProps) {
  const [unread, setUnread] = useState(0);
  const [unreadChats, setUnreadChats] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const refresh = () => void ensureSession().then(() => Promise.all([api.notifications(), api.conversations()])).then(([notifications, conversations]) => {
      if (!cancelled) {
        setUnread(notifications.unread_count);
        setUnreadChats(conversations.conversations.reduce((sum, conversation) => sum + conversation.unread_count, 0));
      }
    }).catch(() => undefined);
    refresh();
    const timer = window.setInterval(refresh, 8000);
    return () => { cancelled = true; window.clearInterval(timer); };
  }, [currentRoute]);
  const tabs = [
    { id: 'home', label: 'Home', icon: '⌂', path: '/' },
    { id: 'notifications', label: 'Notification', icon: '♧', path: '/notifications' },
    { id: 'chat', label: 'Chat', icon: '•••', path: '/chat' },
    { id: 'profile', label: 'User', icon: '♙', path: '/profile' },
  ];

  return (
    <nav className="bottom-nav-bar" role="navigation" aria-label="Thanh điều hướng chính">
      {tabs.map((tab) => {
        const isActive =
          tab.path === '/'
              ? currentRoute === '/' || currentRoute === '' || currentRoute === '/friends'
              : tab.id === 'profile'
                ? currentRoute.startsWith('/profile') || currentRoute === '/history' || currentRoute === '/leaderboard' || currentRoute === '/privacy'
            : currentRoute.startsWith(tab.path);

        return (
          <button
            key={tab.id}
            className={`bottom-nav-tab ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="tab-icon">{tab.icon}{tab.id === 'notifications' && unread > 0 && <span className="nav-unread">{unread > 9 ? '9+' : unread}</span>}{tab.id === 'chat' && unreadChats > 0 && <span className="nav-unread">{unreadChats > 9 ? '9+' : unreadChats}</span>}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
